import { render, staticRenderFns } from "./ProductPicker.vue?vue&type=template&id=2d3e4f7d&scoped=true&"
import script from "./ProductPicker.vue?vue&type=script&lang=js&"
export * from "./ProductPicker.vue?vue&type=script&lang=js&"
import style0 from "./ProductPicker.vue?vue&type=style&index=0&id=2d3e4f7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3e4f7d",
  null
  
)

component.options.__file = "ProductPicker.vue"
export default component.exports